import React from "react";
type Props = {
  className?: string;
};

const IconArrowLeft = (
  props: Props
): React.ReactElement<React.ComponentProps<"svg">, "svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={props.className}
  >
    <title id="title">Arrow Left</title>
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <g fill="#4DA1A9" fillRule="nonzero">
              <g>
                <path
                  d="M5.333 10.402L0.1 5.25 5.333 0.098 5.8 0.558 1.033 5.25 5.8 9.942z"
                  transform="translate(-20 -121) translate(20 120) translate(0 1) translate(0 1.4)"
                />
                <path
                  d="M0.567 4.922H13.9V5.922H0.567z"
                  transform="translate(-20 -121) translate(20 120) translate(0 1) translate(0 1.4)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default IconArrowLeft;
